<ul class="nav nav-tabs t-{{tabs.length}}" id="tabs"
    joyrideStep="tabsStep"
    [stepContent]="tabsStepContent">
    <li class="nav-item nav-item-{{tab.slug}}" *ngFor="let tab of tabs">
        <a *ngIf="tab.slug != 'inout' && tab.slug != 'impot'" class="nav-link" [routerLink]="[path, tab.slug]" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: false, __change_detection_hack__: favorite.id }">
            <i class="icon icon-{{ tab.slug }}"></i>
            <span>{{ tab.title }}</span>
        </a>
        <a *ngIf="tab.slug == 'inout'" class="nav-link" [routerLink]="[path, tab.slug]" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: false, __change_detection_hack__: favorite.id }"
           joyrideStep="inoutTabsStep"
           [stepContent]="inoutStepContent">
            <i class="icon icon-{{ tab.slug }}"></i>
            <span>{{ tab.title }}</span>
        </a>
        <a *ngIf="tab.slug == 'impot'" class="nav-link" [routerLink]="[path, tab.slug]" routerLinkActive="active"
           [routerLinkActiveOptions]="{exact: false, __change_detection_hack__: favorite.id }"
           joyrideStep="impotTabsStep"
           [stepContent]="impotTabsStepContent">
            <i class="icon icon-{{ tab.slug }}"></i>
            <span>{{ tab.title }}</span>
        </a>
    </li>
</ul>

<ng-template #tabsStepContent>
    <div class="user_onboarding_content">
        <h2>Navigation dans votre simulation</h2>
        <p>
            Votre simulation est divisée en plusieurs étapes. Vous y retrouverez :
        </p>
        <ul>
            <li>Une <b>présentation</b> de l’annonce</li>
            <li>Une analyse de la <b>ville</b></li>
            <li>Un simulateur de <b>travaux</b></li>
            <li>Un calculateur de <b>rendement</b> et de <b>cash-flow</b></li>
            <li>Un simulateur de <b>fiscalité</b> sur vos revenus locatifs</li>
            <li>Un <b>récapitulatif</b> des chiffres clés</li>
            <li>Un <b>dashboard</b> entièrement personnalisable</li>
        </ul>
        <p>
            Vous pouvez passer facilement d’un onglet à un autre pour aller droit à l’essentiel.
        </p>
    </div>
</ng-template>
<ng-template #inoutStepContent>
    <div class="user_onboarding_content">
        <h2>Onglet rendement</h2>
        <p>
            Partons directement dans le vif du sujet, le <b>rendement locatif</b> de votre projet !
        </p>
    </div>
</ng-template>
<ng-template #impotTabsStepContent>
    <div class="user_onboarding_content">
        <h2>Onglet imposition</h2>
        <p>
            Vous voulez savoir <b>quel est le meilleur régime fiscal</b> pour votre projet et combien d’impôts vous devrez payer ?<br/>
            <br/>
            Tous les chiffres que vous avez renseignés dans l’onglet “Rendement” vont être réutilisés pour <b>calculer votre fiscalité</b>.<br/>
            <br/>
            Suivez-moi, c’est par ici !
        </p>
    </div>
</ng-template>
